export enum LenderName {
    USHA = 174,
    SAMASTA = 176,
    RBL = 179,
    DCB = 180,
    IDFC = 181,
    DMI = 182,
    FULLERTON = 183,
    INCRED = 184,
    TATA = 186,
    EKAGRATA = 190,
    AXIS = 191,
    HDB = 193,
}

export const lenderDetails = {
    174: "USHA",
    176: "SAMASTA",
    179: "RBL",
    180: "DCB",
    181: "IDFC",
    182: "DMI",
    183: "FULLERTON",
    184: "INCRED",
    186: "TATA",
    190: "EKAGRATA",
    191: "AXIS",
    193: "HDB",
};

export const getLenderName = (id: number) => {
    return lenderDetails.hasOwnProperty(id) ? lenderDetails[id].toLowerCase() : null;
};
